import React from "react";
import { useTranslation } from "react-i18next";
import { CustomModalWeb } from "../../../web/pages/userProfile/CustomModalWeb";
import { GetQualifiedProps } from "./types";
import { IONICWrapper } from "../../../utils/common"
import { GET_QUALIFIED_BUTTON_NAME, GET_QUALIFIED_TEXT_MESSAGE } from "../../../utils/constants";

export default ({
  isOpen,
  onClosed,
}: GetQualifiedProps) => {
  const { t } = useTranslation();
  const GetQualifiedModalProps = {
    isModalOpen: isOpen,
    title: IONICWrapper.details.getKeyValuePairs("get_qualified_button_title") || GET_QUALIFIED_BUTTON_NAME,
    contentAlignment: "left",
    size: "extra_small_height",
    message: IONICWrapper.details.getKeyValuePairs("get_qualified_message_text") || GET_QUALIFIED_TEXT_MESSAGE,
    contentScroll: "deny",
    buttons: [
      {
        title: t("Ok"),
        type: "primary-cta-btn-web",
        onClick: () => {
          onClosed();
        }
      }
    ]
  };
  return (
    <CustomModalWeb {...GetQualifiedModalProps} data-testid="customModal">
    </CustomModalWeb>
  );
};
